//印尼语
export default {
	pay: {
		waitPay          : "Menunggu Pembayaran",
		purchase         : "Membeli",
		totalAmount      : "Jumlah Total",
		otherMethods     : "Metode Pembayaran Lainnya",
		payAmount        : "Jumlah Pembayaran",
		payMethod        : "Metode Pembayaran",
		payTime          : "Waktu Pembayaran",
		complete         : "Selesai",
		successfulPayment: "Pembayaran Berhasil"
	},
	language: {
		switchLanguage: "tukar bahasa",
		return        : "kembali"
	},
	order: {
		payOrder     : "Bayar pesanan",
		payAmount    : "Jumlah pembayaran",
		payType      : "Cara Pembayaran",
		payStatus    : "Status pembayaran",
		selectPayment: "Pilih metode pembayaran",
		copy         : "menyalin",
		expires      : "Tidak sah",
		orderId      : "Id pemesanan",
		orderDetail  : "Detail pesanan",
		refresh      : "Menyegarkan",
		havePaid     : "Dibayar",
		retry        : "Mencoba",
		use          : "menggunakan",
		problems     : "Apakah Anda mengalami masalah dengan pembayaran?",
		otherOne1    : "Cara membayar melalui ATM",
		otherOne2    : "1.Kunjungi ATM terdekat sebelum kedaluwarsa.",
		otherOne3    : "2.Lakukan transfer menggunakan fungsi transfer ATM.",
		otherOne4    : "3.Verifikasi kode pembayaran di atas dan masukkan transfer.",
		otherOne5    : "4.Lakukan pembayaran sesuai dengan jumlahnya.",
		otherTwo1    : "Cara membayar via online",
		otherTwo2    : "1.Akses bank online yang sesuai sebelum kedaluwarsa.",
		otherTwo3    : "2.Lakukan transfer menggunakan fungsi transfer bank online.",
		otherTwo4    :
      "3.Verifikasi kode pembayaran di atas dan masukkan kode tersebut.",
		otherTwo5         : "4.Bayar sesuai dengan jumlahnya.",
		otherThree1       : "Cara membayar melalui M-Banking",
		otherThree2       : "1.Kunjungi bank terdekat sebelum kedaluwarsa.",
		otherThree3       : "2.Beritahu kasir untuk melakukan pembayaran.",
		otherThree4       : "3.Katakan atau tunjukkan kode pembayaran di atas.",
		otherThree5       : "4.Bayar sesuai dengan jumlahnya.",
		rechargeSuccessful: "Isi ulang berhasil",
		gold              : "Emas",
		rewardCoins       : "Hadiahi koin",
		ovo               : "Pembayaran OVO",
		amountDue         : "Jumlah yang Harus Dibayar",
		changePayment     : "Ganti Cara Bayar",
		proceedtoPay      : "Lanjut Bayar",
		phoneNumber       : "Nomor Telepon",
		phoneNumber       : "Nomor telepon",
		phoneNumber2      : "Silakan masukkan nomor telepon yang valid",
		phoneNumber3      : "Silakan masukkan nomor telepon Anda",
		orderForm1        : "Pesanan telah dibuat",
		orderForm2        : "Silakan lanjutkan ke",
		orderForm3        : "Menyelesaikan pembayaran"

	},

	recharge: {
		recharge             : "Isi Ulang",
		coins                : "Koin",
		bonus                : "Bonus",
		GoldCoinRechargeRules: "Aturan Pengisian Koin Emas:",
		goldCoinsAreVirtual  :
      "Koin emas adalah barang virtual dan tidak dapat dikembalikan. Mereka hanya digunakan untuk membuka konten premium dalam aplikasi.",
		expiredDeletion:
      "Kesetaraan pengisian: 1 koin emas = 1 bonus. Harap dicatat bahwa pengembalian dana pengisian ulang tidak didukung.",
		expiredWillBeInvalidated:
      "Pastikan untuk menggunakan koin bonus yang diperoleh melalui pengisian ulang atau partisipasi dalam kegiatan dalam periode berlaku, karena mereka akan menjadi tidak valid setelah kedaluwarsa.",
		goldCoinsNotReceived:
      "Jika koin tidak dikreditkan tepat waktu setelah pengisian ulang, silakan keluar dari aplikasi dan periksa lagi.",
		rechargeAgreement: "Isi ulang menyiratkan",
		protocol         : "《Perjanjian Isi Ulang》",
		specialOffer     : "Pertama",
		extra            : "Ekstra",
		unlockAll        : "Buka kunci episode secara otomatis",
		day              : "Hari",
		subscribe        : "Berlangganan",
		price            : "Harga",
		goldMall         : "Mal Koin Emas",
		balance          : "Keseimbangan",
		unlock           : "Buka kunci",
		episode          : "Episode",
		timeLimited      : "Setoran pertama dengan waktu terbatas",
		time             : "Waktu terbatas",
		otherOptions     : "Pilihan lain",
		luckyUser        : "Selamat telah terpilih menjadi pengguna yang beruntung dengan paket diskon terbaik",
		HH               : "HH",
		MM               : "mm",
		SS               : "ss",
		payNow           : "Bayar sekarang",
		unlockWeek       : "satu minggu buka semua seri",
		unlockMonth      : "satu bulan buka semua seri",
		unlockYear       : "satu tahun buka semua seri",
		renew            : "Perpanjangan",
		next             : "Selanjutnya",
		newUser          : "hadiah untuk pengguna baru",
		only             : "Wanya sekali",
		left             : "",
		monthly          : "bulan",
		annual           : "tahun",
		weekly           : "minggu",
		firstWeek        : "Minggu pertama"
	},
	home: {
		loading        : "Memuat data...",
		all            : "eps",
		ep             : "eps",
		classification : "klasifikasi",
		recentlywatched: "Baru saja melihat",
		collection     : "Tandai",
		language       : "Bahasa",
		logOut         : "Keluar",
		refresh        : "Segar",
		login          : "Masuk"
	},
	otherpage: {
		otherpage1: "Setelah mengisi koin emas, koin emas tertunda dalam tiba",
		otherpage2:
      "Karena masalah jaringan, kedatangan koin emas mungkin tertunda. Dalam kasus seperti itu, Anda perlu menunggu jaringan membaik dan kemudian pergi ke halaman pengisian ulang. Jika masih tidak berhasil, Anda akan menerima pengembalian dana dari Google atau Apple setelah 3 hari.",
		otherpage3:
      "Jika koin emas tidak dikreditkan tepat waktu, mungkin karena kemacetan jaringan yang menyebabkan penundaan. Jangan khawatir, sistem akan memverifikasi ulang, dan umumnya, koin akan dikreditkan secara otomatis pada pukul 18:00 pada hari kerja kedua. Jika karena alasan lain koin masih belum dikreditkan, jumlah tersebut akan dikembalikan ke akun pembayaran asli dalam waktu tiga hari kerja.",
		otherpage4    : "Umpan Balik",
		inviteFriends1: "Seri TV populer",
		inviteFriends2:
      "Tonton satu episode setelah masuk ke ReelBuzz, teman bisa mendapatkan hadiah BOINS",
		inviteFriends3: "Petunjuk：",
		inviteFriends4: "Unduh",
		inviteFriends5: "Seri TV populer",
		inviteFriends6: "Invite friends",
		inviteFriends7: "Tidak dapat berlangganan lagi",
		jelaskan1     :
      "Instruksi Langganan:\n• Pembelian Keanggotaan: Periode pembelian adalah 30 hari, 365 hari, atau 7 hari. Harga pembelian tergantung pada produk.\n• Perpanjangan Langganan: Akun Google Pay akan dikenakan biaya 24 jam sebelum tanggal kedaluwarsa. Setelah pembayaran berhasil, langganan akan diperpanjang untuk satu periode.Layanan langganan akan berlanjut hingga dibatalkan.\n• Batalkan Langganan: Buka Google Pay - Langganan - Pilih Reelbuzz untuk membatalkan langganan.\n• Tidak Ada Pengembalian Dana: Setelah layanan keanggotaan diaktifkan, tidak ada pengembalian dana yang akan diberikan, dan tidak berlaku untuk kebijakan pengembalian tanpa alasan.\n• Jika Anda memiliki pertanyaan tentang layanan keanggotaan, klik Saya - Umpan Balik, masuk ke halaman umpan balik, dan hubungi kami. Staf layanan pelanggan kami akan menangani masalah Anda.",
		questionnaire: "Kuesioner"
	},
	whatsapp: {
		paling           : "Paling populer",
		countDown        : "Hitung Mundur",
		extra            : "Ekstra",
		rules            : "Aturan Acara",
		eventDuration    : "Durasi Acara: Diskon isi ulang ini berlaku selama 24 jam.",
		eventDuration2   : "Cara Berpartisipasi: Pengguna dapat mengisi ulang melalui halaman acara untuk mendapatkan hadiah tambahan.",
		eventDuration3   : "Batas Partisipasi: Setiap pengguna hanya memiliki satu kesempatan untuk berpartisipasi dan hanya dapat memilih salah satu dari dua opsi isi ulang.",
		rechargeAgreement: "Isi ulang berarti menyetujui \"Perjanjian Isi Ulang\"",
		exclusive        : "Acara Eksklusif",
		event            : "Acara"
	},
	prizeDraw: {
		ruleTip         : "Aturan Acara",
		rules1          : "1. Selama periode acara, halaman utama akan menampilkan pop-up dan widget pintu masuk acara, memungkinkan pengguna untuk memasuki halaman acara. ",
		rules2          : "2. Pengguna yang berhasil berlangganan melalui promosi ini akan secara otomatis mengaktifkan fitur perpanjangan langganan.  ",
		rules3          : "3. Selama periode langganan, pengguna dapat menonton semua drama tanpa batas.  ",
		rules4          : "4. Setelah berhasil berlangganan, pengguna akan otomatis terdaftar dalam undian hadiah ponsel. Setelah acara berakhir, pengguna dapat memeriksa hasil undian.  ",
		rules5          : "5. Setelah pembelian, pengguna dapat membatalkan langganan kapan saja. Dalam 24 jam sebelum periode langganan saat ini berakhir, akun Anda akan secara otomatis diperpanjang dan biaya akan dipotong.  ",
		rules6          : "6. Jika Anda memiliki pertanyaan, silakan hubungi layanan pelanggan: **Profil → Layanan Pelanggan**. ",
		rules7          : "7. **Reelbuzz memiliki hak interpretasi akhir atas promosi ini.**",
		stepsTip        : "Ikuti undian ponsel",
		step1           : "Langkah pertama: Menjadi anggota dan otomatis mendaftar ke acara~",
		step2           : "Langkah kedua: Tunggu pengumuman hasil undian setelah acara berakhir.",
		step3           : "Langkah ketiga: Periksa pengumuman hasil undian.",
		step4           : "Langkah keempat: Jika Anda memenangkan hadiah, harap tinggalkan kontak Anda, dan staf kami akan menghubungi Anda.",
		nubiaPhonetip   : "menjelang Hari Raya Idul Fitri, sebagai bentuk terima kasih atas dukungan Anda terhadap Reelbuzz, kami akan membagikan sejumlah hadiah. Klik tombol pendaftaran untuk mengikuti undian, dan Anda berkesempatan memenangkan smartphone terbaru",
		prizeInformation: "Informasi Hadiah",
		signup          : "Daftar",
		sorry           : "Mohon maaf",
		activityOver    : "cara telah berakhir.",
		congratulation  : "Selamat, Anda menang!",
		sorryForNotYou  : "Sayangnya, Anda tidak memenangkan hadiah.",
		uncommitted     : "Anda tidak ikut serta dalam acara ini",
		name            : "Nama ",
		phone           : "Nomor telepon",
		getcode         : "Dapatkan",
		code            : "Kode verifikasi",
		vipUser         : "Anggota",
		firstWeek       : "Minggu pertama",
		everyWeek       : "minggu",
		originWeek      : "Setiap minggu",
		allFree         : "Semua episode bisa ditonton gratis",
		joinPrize       : "Ikuti undian ponsel.",
		priceDown       : "Diskon",
		Register        : "Daftar undian",
		dearVip         : "Pelanggan yang terhormat",
		signupSuccess   : "Pendaftaran berhasil",
		waitResult      : "Harap funggu pengumuman hasil",
		connectWay      : "Tinggalkan kontak Anda",
		hasconnectWay   : "Kontak telah disediakan",
		usernickName    : "Nama pengguna",
		prize           : "Hadiah",
		pleaseName      : "Silakan isi nama",
		pleaseCode      : "Silakan isi kode verifikasi.",
		pleasePhone     : "Silakan isi nomor ponsel",
		subSuccess      : "Pengiriman berhasil.",
		submit          : "Konfirmasi",
		cancleTip       : "erpanjangan otmatis batalkan kapan saja",
		phoneName       : "Ponsel"
	},
	inviteActivity: {
		startInvite   : "Mulai mengundang teman",
		invite        : "Undang teman",
		couponNumber  : "kupon undian",
		getIcons      : "Bonus",
		activityTitle : "Aktivitas hadiah",
		titleStep1    : "Undang pengguna untuk mengunduh Reelbuzz",
		titleStep2    : "Pengguna menonton selama 10 menit",
		titleStep3    : "Pengguna melakukan isi ulang",
		activityStep  : "Cara mengundang teman",
		step1         : "Langkah 1: Klik untuk mulai mengundang teman",
		step2         : "Langkah 2: Bagikan tautan ke teman atau posting ke Facebook",
		step3         : "Langkah 3: Teman mengunduh Reelbuzz dan menonton drama pendek",
		step4         : "Langkah 4: Dapatkan koin hadiah dan kupon undian HP",
		step5         : "LLangkah 5: Tunggu hasil undian",
		activityRank  : "Peringkat undangan teman",
		rank          : "Peringkat",
		userName      : "Nama panggilan",
		inviteCount   : "Mendapatkan Hadiah",
		copyLink      : "Salin URL",
		stepText1     : "Langkah Pertama",
		stepText2     : "Langkah Kedua",
		stepcontent1  : "Klik untuk mengunduh",
		stepcontent2  : "Buka aplikasi dan kunjungi halaman aktivitas undang teman",
		nowGet        : "Dapatkan Sekarang",
		getDownnowload: "Unduh sekarang untuk segera mendapatkan",
		direc         : "Menurut saya ini adalah aplikasi drama pendek lokal terbaik di Indonesia. Aplikasi ini memiliki drama pendek lokal Indonesia terbanyak. Kamu bisa mengunduh aplikasi ini untuk merasakan pesona drama pendek. Unduh sekarang!",
		userNick      : "Nama panggilan pengguna yang diundang",
		congradulate  : "Selamat",
		asinviter     : "Sebagai pengguna yang diundang",
		youget        : "Kamu telah mendapatkan",
		getNow        : "Klaim Sekarang",
		mostIcons     : "Dapatkan hingga "
	},
	userCancellationAgreement: {
		details : "Penghapusan akun adalah",
		details2: "tindakan yang tidak dapat dibatalkan.",
		details3: "Sebelum melanjutkan, pastikan Anda telah mencadangkan semua informasi yang terkait dengan akun Anda dan memastikan semua layanan terkait telah ditangani dengan baik.Pendaftaran ulang di kemudian hari hanya akan membuat akun baru.Setelah akun Anda dihapus, Anda tidak akan dapat menggunakan kembali akun tersebut, maupun memulihkan informasi, konten, data, atau layanan apa pun yang terkait dengan akun tersebut di platform Reelbuzz—meskipun Anda mendaftar ulang menggunakan nomor ponsel, alamat email, atau kredensial lain yang sama.Termasuk namun tidak terbatas pada:",
		details4: "1.Semua aset di bawah akun Anda akan dihapus. Dengan menghapus akun, Anda secara sukarela melepaskan semua aset dan hak yang terkait dengan akun, termasuk koin, hadiah, manfaat keanggotaan, dan aset lainnya. Disarankan agar Anda menggunakan semua aset dan menyelesaikan masalah terkait aset sebelum menghapus akun.",
		details5: "Jika Anda menggunakan Google Pay atau Apple Pay, pastikan untuk memeriksa status langganan Anda dan membatalkan perpanjangan otomatis. Jika tidak dibatalkan, Google atau Apple dapat terus menagih biaya langganan sesuai dengan perjanjian Anda dengan mereka. Untuk sengketa atau permintaan pengembalian dana terkait biaya langganan, silakan hubungi Google atau Apple secara langsung.",
		details6: "2.Semua data akun akan dihapus atau dianonimkan. Informasi profil dan data penggunaan Anda akan dihapus atau dianonimkan dan tidak dapat dipulihkan, termasuk namun tidak terbatas pada nama pengguna, alamat email, riwayat tontonan, daftar favorit, riwayat pembelian, riwayat isi ulang, akun login pihak ketiga, dan konten atau informasi apa pun yang Anda tambahkan (baik gratis maupun berbayar).Jika ada konten atau informasi tertentu yang saat ini Anda butuhkan atau mungkin akan Anda butuhkan di masa mendatang, harap pastikan untuk menyimpan salinannya sebelum menghapus akun.",
		details7: "3.Penghapusan akun tidak memengaruhi perjanjian apa pun yang telah Anda buat dengan Reelbuzz. Jika Anda telah menandatangani perjanjian dengan Reelbuzz, perjanjian tersebut tetap berlaku dan kedua belah pihak harus menjalankan kewajibannya sesuai dengan ketentuan. Misalnya, karya yang telah diberi izin tidak akan dihapus sebelum perjanjian berakhir.Untuk informasi lebih lanjut, silakan hubungi kami di:",
		details8: "Jika akun Anda telah dilaporkan oleh pengguna lain, sedang diselidiki oleh aparat penegak hukum, terlibat dalam proses hukum atau arbitrase, atau jika Reelbuzz meyakini (menurut kebijakan tunggal dan mutlaknya) bahwa akun Anda berisiko dicuri atau diblokir (“masalah terminasi”), Reelbuzz berhak menghentikan proses penghapusan akun tanpa pemberitahuan kepada Anda.Setelah Anda mengajukan permintaan penghapusan akun, Anda akan memiliki waktu 30 hari untuk berubah pikiran dan membatalkan penghapusan.Jika dalam periode ini semuanya berjalan lancar dan tidak ada “masalah terminasi”, informasi Anda mungkin memerlukan waktu hingga 120 hari untuk sepenuhnya dihapus atau dianonimkan.Saat Anda menghapus akun, kami akan berupaya sebaik mungkin untuk menghapus semua data pribadi yang terkait dengan akun Anda.Namun, demi tujuan pelaporan keuangan, kami harus menyimpan catatan transaksi sebelumnya dan mungkin perlu mempertahankan informasi tertentu untuk mematuhi perintah pengadilan atau proses hukum lainnya.Kami juga akan menyimpan catatan akun yang dihapus untuk memenuhi kewajiban hukum dan jika diperlukan demi kepentingan sah terkait keamanan akun.Harap diperhatikan bahwa penghapusan akun tidak membebaskan Anda dari tanggung jawab atas tindakan yang dilakukan di akun sebelum penghapusan.",
		details9: "services@reelbuzztv.com。"
	},
	inviteDraw: {
		hasContactWay: "Kontak Telah Disimpan",
		contactWay   : "Masukkan Kontak",
		nickName     : "Nama Panggilan",
		confirm      : "Konfirmasi",
		name         : "Nama Lengkap",
		rank         : "Peringkat",
		getReward    : "Dapatkan Hadiah",
		youHasGot    : "Anda telah mendapatkan",
		sorry        : "Anda tidak berpartisipasi dalam acara ini",
		phone        : "Nomor Ponsel",
		getCode      : "Dapatkan Kode",
		code         : "Kode SMS",
		rules1       : "1. Selama periode acara, pengguna yang berpartisipasi dapat memperoleh hadiah Bonus dan kupon undian ponsel melalui mengundang teman.",
		rules2       : "2. Setelah acara berakhir, secara acak akan dipilih 5 pengguna yang memegang kupon undian untuk memenangkan ponsel nubia smartPhone; semakin banyak kupon yang dimiliki, semakin besar peluang menang.",
		rules3       : "3. Hadiah Bonus akan langsung dikirim ke saldo akun pengguna secara real time.",
		rules4       : "4. Peringkat disusun dari hadiah terbanyak ke terendah; jika hadiah sama, diurutkan berdasarkan waktu penyelesaian.",
		rules5       : "5. Jika ada pertanyaan, silakan hubungi Layanan Pelanggan: Profil - Layanan Pelanggan.",
		rules6       : "6. **Reelbuzz memiliki hak interpretasi akhir atas promosi ini.**",
		totalGet     : "Anda telah memperoleh dalam acara ini"
	},
	catGame: {
		saleSuccess      : "Penjualan Berhasil Bnous+",
		thinkAgain       : "Batal",
		confirmSale      : "Jual",
		saleTip          : "Setelah dijual tidak bisa dibatalkan, kucing akan hilang selamanya",
		saleNumber       : "Jumlah Dijual",
		sale             : "Jual",
		noThisCat        : "Belum mendapatkan kucing ini~",
		inventory        : "Stok ",
		saleCat          : "Jual Kucing",
		noMore           : "Tidak ada lagi~",
		heHasNocat       : "Dia belum punya anak kucing~",
		youcanPet        : "Hari ini masih bisa elus",
		youcanPetTime    : "kali~",
		downReelBuzz     : "Unduh Reelbuzz",
		adoptCat         : "adopsi kucing~",
		petCat           : "Elus anak kucing",
		adoptMycat       : "Adopsi anak kucingku~",
		catPending       : "Bola Kucing Menunggu~",
		addToGallery     : "Tambahkan ke Galeri Anak Kucing",
		addToBag         : "Tambahkan ke dalam koleksi dan jual",
		notSell          : "Belum membeli untuk sekarang",
		raisingCountdown : "Hitung Mundur Membesarkan",
		continueRaising  : "Lanjut Membesarkan",
		congrats         : "Selamat, kamu mendapat",
		open             : "Buka",
		openCat          : "Buka Bola Kucing",
		noRecords        : "Belum ada catatan",
		tips             : "Petunjuk:",
		tipOne           : "Setiap anak kucing bisa dielus 10 kali saat menetas~",
		tipTwo           : "Setiap anak kucing bisa dielus 15 kali saat dibesarkan~",
		tipThree         : "Berhasil mengundang teman menginstal & daftar Reelbuzz untuk koin hadiah",
		pettedYourcat    : "Membelai anak kucingmu",
		catLog           : "Catatan Membelai",
		others           : "Lainnya",
		copyUrl          : "Salin URL",
		copySuccess      : "URL disalin",
		shareNow         : "Bagikan",
		startPush        : "Aktifkan notifikasi, terima status penetasan",
		notification     : "Notifikasi Aktivitas",
		shareFriendOne   : "Bagikan ke teman",
		shareFriendTwo   : "Elus anak kucing",
		acceptPush       : "Terima Notifikasi",
		hatchingCountdown: "Hitung Mundur Penetasan",
		ruleOne          : "Menonton selesai satu drama dapat Bola Kucing~",
		ruleTwo          : "Saat ini ada anak kucing menetas ",
		ruleThree        : "Ambil Bola Kucing dari riwayat tontonan profil",
		ruleFour         : "Penetasan & membesarkan butuh waktu, undang teman untuk mengelus kucing mempercepat~",
		ruleFive         : "Kucing dewasa setelah menetas masuk galeri",
		ruleSix          : "Mendapat kucing dewasa duplikat bisa dijual di tas",
		startHatching    : "Menetaskan",
		catBall          : "Bola Kucing",
		catHouse         : "Kucing",
		catGallery       : "Galeri Anak Kucing",
		myBag            : "Tas Kucingku",
		catchRaising     : "Panduan Kucing",
		goHome           : "Kembali ke Rumah",
		selectCat        : "Pilih Satu Bola Kucing",
		raisingSuccess   : "Berhasil Membesarkan",
		rasing           : "Membesarkan:",
		waitOpen         : "Akan Dibuka",
		hatching         : "Menetaskan:",
		hatchingSuccess  : "Penetasan berhasil:",
		freeTime         : "Sedang Senggang",
		confirm          : "Konfirmasi",
		pleaseEnterName  : "Masukkan Julukan",
		nickName         : "Julukan",
		putAway          : "Simpan dulu~",
		startRaising     : "Mulai Memelihara Kucing",
		yayGot           : "Hore, dapat Bola Kucing ",
		claimCatball     : "Ambil",
		viewingHistory   : "Riwayat Ditonton",
		square           : "Alun-alun",
		home             : "Beranda",
		myCat            : "Kucing",
		raisingCat       : "Pelihara Seekor Anak Kucing",
		nocatYey         : " Belum punya anak kucing, ayo adopsi satu~",
		grown            : "Percepatan pertumbuhan",
		dramaCommend     : "Rekomendasi Drama Pendek",
		watchEpisodes    : "Menonton Episode",
		Raise            : "Membesarkan",
		Hatch            : "Menetas",
		redeemRewards    : " Tukar Hadiah",
		welcomeTo           : "Selamat datang di",
		ofCatHouse          : "Rumah Kucing",
		goToSquare          : "Pergi ke Plaza",
		hatchComplete       : "Penetasan Selesai",
		hatchCompleteTip    : "Anak kucing sudah menetas, ayo lihat~",
		petSpeedTip         : "Belaian dapat mempercepat pertumbuhan 1 jam, maksimal 10 kali",
		petToSpeedHatch     : "Anak kucing sedang menetas, sentuh untuk mempercepat",
		maxPetTimes         : "Setiap anak kucing dapat menerima maksimal 10 belaian",
		someoneHelped       : "Dibantu Percepat",
		helpedOneHour       : "Dipercepat 1 Jam",
		hasLiked            : "Disukai",
		like                : "Suka",
		setFavorite         : "Atur Favorit",
		catRanking          : "Peringkat",
		viewProfile         : "Profil",
		rankingUpdateTip    : "Diperbarui tiap 00:00",
		raiseCats           : "Pelihara Kucing",
		catUnit             : "Ekor",
		selectMonth         : "Pilih Bulan",
		dramaLovingCat      : "Kucing pecinta drama~",
		clickTap            : "Ketuk",
		giveLike            : "Beri dia suka",
		favoriteDrama       : "Drama Favorit",
		change              : "Ganti",
		watch               : "Tonton",
		noFavoriteDramaClick: "Belum ada drama favorit, ketuk untuk memilih",
		noFavoriteDrama     : "Belum ada drama favorit",
		bio                 : "Bio",
		male                : "Pria",
		female              : "Wanita",
		likeHistory         : "Riwayat Suka",
		likedYou            : "Menyukai kamu",
		noLikeHistory       : "Belum ada riwayat suka",
		operationFailed     : "Operasi Gagal"
	},
	yearlyReport: {
		title        : "Selamat datang di Laporan Menonton Tahunan 2025",
		startReport  : "Buka riwayat saya",
		iAgree       : "Saya sudah membaca dan menyutujui",
		yearlyReport : "Perjanjian Layanan Laporan Tahunan",
		firstTime    : "Waktu pertama kali kamu masuk ke ReelBuzz adalah",
		firstDate    : "Jarak waktu sejak masuk pertama",
		hasPast      : "Sudah melewati",
		day          : "hari",
		thenYouwatch : "Setelah itu, kamu sudah menonton",
		topContinue  : "Geser ke atas untuk lanjut",
		morning      : "Pagi",
		afternoon    : "Siang",
		night        : "Malam",
		linchen      : "Dini hari",
		earlyTime    : "Kamu pertama kali menonton drama pada",
		latestTime   : "Terakhir kali kamu menonton drama pada",
		hopeDate     : "Semoga setiap hari-hari yang sibuk pun selalu ada cerita yang menemani",
		hopeNight    : "Semoga setiap malam yang sepi selalu ada cerita yang menemani",
		thisYear     : "Sepanjang tahun ini",
		youWatch     : "Kamu telah menonton total",
		episodes     : "drama",
		pass         : "Melebihi",
		users        : "pengguna",
		youFavorite  : "Genre yang paling kamu suka adalah",
		youloveIsBest: "Yang kamu sukai memang yang terbaik!",
		loveActors   : "Kamu paling suka menonton drama yang mereka bintangi",
		suprice      : "Kami telah menyiapkan kejutan khusus untukmu",
		aLetterFrom  : "Sepucuk surat dari",
		and          : "dan",
		letter       : ".",
		content      : "Terima kasih atas dukungan dan ketertarikanmu, semoga ke depannya kita semua mendapat banyak hal baik dan semoga di tahun baru ini kamu selalu bahagia",
		reportYear   : "Selamat datang di Laporan Menonton Tahunan 2025",
		shortStory   : "Beberapa cerita sangat pendek",
		youStop      : "Tapi kamu mau berhenti sejenak untuk menikmatinya",
		thanksWatch  : "Terima kasih untuk setiap tontonanmu",
		seeAgain     : "Tonton lagi",
		share        : "Bagikan sekarang",
		maybe        : "Mungkin kamu belum",
		likeactors   : "memiliki aktor favorit",
		butlike      : "namun rasa suka sedang tumbuh...",
		openLetter   : "Ketuk surat di bawah ini untuk membukanya",
		all          : "Menemani kamu selama",
		allWatch     : "Total menonton",
		cancle       : "Batal",
		argee        : "Setuju",
		confirm      : "Konfirmasi",
		noProtocol   : "Belum ada riwayat tontonan",
		document     : "Saya menyetujui dan memberikan izin kepada platform, sesuai dengan ketentuan hukum yang berlaku, untuk menggunakan riwayat tontonan dan data interaksi saya di dalam platform guna menghasilkan dan menampilkan laporan tahunan pribadi. Informasi tersebut hanya digunakan untuk keperluan laporan tahunan, dan platform akan mengambil langkah-langkah yang wajar sesuai hukum untuk melindungi keamanan data pengguna serta tidak akan mengungkapkan informasi yang dapat mengidentifikasi identitas pribadi kepada pihak ketiga tanpa izin."
	},
	valentineDay: {
		notExpired        : "Belum",
		completed         : "Selesai",
		go                : "Selesaikan",
		exchange          : "Tukar hadiah",
		exchanged         : "Ditukar",
		exchangeCount     : "Jumlah penukaran",
		taskType1         : "Login harian",
		taskType2         : "Login di Hari Valentine",
		taskType3         : "Total nonton lebih dari",
		taskType4         : "Tonton 2 iklan video",
		taskType5         : "Tonton 1 drama penuh",
		taskType6         : "Berlangganan VIP",
		taskType7         : "Tonton",
		taskType8         : "Undang 1 pengguna baru",
		taskType9         : "Bagikan ke teman",
		taskType10        : "Login di Hari Valentine",
		heartValue        : "Poin Jantung",
		rule              : "Aturan",
		shareTitle        : "Bagikan untuk dapat poin",
		headFrame         : "Bingkai Avatar",
		coin              : "Koin Hadiah",
		receiveReward     : "Klaim",
		valentinaHeadFrame: "Bingkai Valentine",
		hadSeen           : "Ditonton",
		pushMe            : "Ingatkan saya",
		changeTimes       : "Jumlah penukaran",
		got               : "Didapat",
		day               : "hari",
		detail            : "Rincian",
		income            : "Pemasukan",
		expenditure       : "Pengeluaran",
		noData            : "Tidak ada detail",
		gotoActivity      : "Ke halaman acara",
		pleaseUpgrade     : "Harap perbarui aplikasi ke versi terbaru",
		minute            : "menit",
		over              : "Berakhir",
		activityOver      : "Kegiatan telah berakhir",
		seeName           : "Tonton 《Cinta Lama Bertemu Kembali》",
		countTime         : "Sisa waktu",
		dayilyTask        : "Tugas harian",
		specialTask       : "Tugas spesial",
		eventRewards      : "Hadiah Event",
		notRelease        : "Drama ini belum dirilis",
		rulesContent      : "Waktu Acara:4 Februari 2026 pukul 00.00 – 19 Februari 2026 pukul 23.59. Selama acara, selesaikan tugas harian dan tugas acara tertentu untuk mendapatkanHeart Point. Heart Point dapat ditukarkan dengankeanggotaan VIP,bingkai avatar eksklusif Hari Valentine, danBonus. Heart Point yang tidak digunakan akan hangus setelah acara berakhir. Aturan dan hadiah mengacu pada tampilan halaman acara."
	},
	caimH5: {
		onlyleft          : "Hanya kurang ",
		canGet            : "lagi untuk Withdraw",
		hasGot            : "Jumlah yang Sudah Didapat",
		//待获得金额
		pendingGet        : "Jumlah yang Akan Didapat",
		//距离
		distance          : "Jarak ke",
		onlyDiamond       : "Kurang Berlian",
		pendingDiamond    : "Jumlah yang Akan Berlian",
		rules             : "Peraturan",
		rewordsList       : "Catatan Hadiah",
		inviteFriends     : "Undang Teman",
		getRewards        : "Dapatkan ",
		//抽奖
		drawChance        : "x Kesempatan Undian",
		chance            : "Kesempatan",
		//助力记录
		helpRecord        : "Catatan Bantuan",
		close             : "Tutup",
		//再送您
		againSendYou      : "Diberikan lagi",
		justInvite        : "Cukup undang",
		oneFriend         : "1 teman mendaftar",
		register          : "mendaftar",
		//太棒啦，获得
		great             : "Hore! Dapat",
		//谢谢惠顾
		thanksForVisiting : "Terima Kasih",
		shareTitle        : "Bagikan ke teman untuk dapat kesempatan hadiah",
		//点击
		clickToDownload   : "Klik untuk Unduh ReelBuzz",
		downLoadandEnter  : "Unduh ReelBuzz & Masuk",
		clickToParticipate: "Klik untuk Ikut Event",
		enterReelbuzz     : "Masuk ke ReelBuzz untuk ikut event Withdraw",
		getMoney          : "Dapatkan Hadiah Tunai",
		getMoneyNow       : "Selesaikan syarat event dan dapatkan hadiah tunai"
	},
	sacrifice: {
		tomorrowOpen: 'Klaim besok',
		immediatelyReserve: 'Pesan Sekarang',
		reserveSuccess: 'Sudah Dipesan',
		immediatelyWatch: 'Tonton Sekarang',
		indonesianOriginal: 'Lokal',
	},
};
